/**
 * Groups Management Page
 *
 * Role-branched at the `/groups` route:
 *  - Admins get the account-wide GroupsDirectory (create / edit / bulk),
 *    the same component the Workspaces editor's Groups tab mounts locked.
 *  - A learner who owns a group (the "group admin") gets the read-only
 *    MyGroups surface — their group's roster + compliance reporting. The
 *    admin directory calls admin-only endpoints, so learners never mount it.
 */

import { useSelector } from 'react-redux';
import { UserRole } from '../apis/api-client';
import { RootState } from '../types';
import { Box } from '../components/ui';
import GroupsDirectory from '../components/groups/GroupsDirectory';
import MyGroups from '../components/groups/MyGroups';

export default function GroupsPage() {
  const role = useSelector((state: RootState) => state.profile.user?.role);

  if (role === UserRole.User) {
    return (
      <Box sx={{ p: 4 }}>
        <MyGroups />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'white' }}>
      <Box sx={{ flexGrow: 1 }}>
        <Box sx={{ p: 4 }}>
          <GroupsDirectory />
        </Box>
      </Box>
    </Box>
  );
}
